import { useEffect } from 'react'
import Layout from '../components/layout/Layout'
import { useMDXContent } from '../hooks/useMDXContent'

function LandingPage() {
  const Content = useMDXContent()

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash
      if (hash) {
        // Small delay to ensure content is rendered
        setTimeout(() => {
          const element = document.querySelector(hash)
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        }, 100)
      }
    }

    // Handle initial hash on mount
    handleHashChange()

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange)

    return () => {
      window.removeEventListener('hashchange', handleHashChange)
    }
  }, [])

  return (
    <Layout>
      <div className='container'>
        <Content />
      </div>
    </Layout>
  )
}

export default LandingPage
